import { motion } from "framer-motion";

/* Line-by-line masked reveal for large headings */
export default function KineticLines({
  lines = [],
  className = "",
  as: Tag = "h1",
  stagger = 0.12,
  delay = 0.1,
  italicIdx = null,
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.05,
              ease: [0.16, 1, 0.3, 1],
              delay: delay + i * stagger,
            }}
            className={`inline-block ${italicIdx === i ? "italic" : ""}`}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
